






























































import Vue from 'vue';
import {DateTimeFormats} from "@/components/properties/settings/export/model/DateTimeFormats";
import draggable from 'vuedraggable';
import {i18n} from "@/main";

interface PrefixConfig {
  id: number;
  type: string;
  staticValue: string;
  format?: string;
}

interface PrefixConstant {
  text: string;
  value: string;
}

export default Vue.extend({
  name: 'ManualPatternBuilder',
  props: {
    initialPattern: {
      type: String,
      default: ''
    },
    exportTypeFileShort: String
  },
  components: {
    draggable
  },
  computed: {
    DateTimeFormats() {
      return DateTimeFormats;
    }
  },
  data() {
    return {
      prefixes: [] as PrefixConfig[],
      separator: '_',
      separatorOptions: [
        {text: i18n.tc('export.autoExport.fileNamePattern.underscore'), value: '_'},//'Underscore (_)'
        {text: i18n.tc('export.autoExport.fileNamePattern.dash'), value: '-'},//'Dash (-)',
        {text: i18n.tc('export.autoExport.fileNamePattern.period'), value: '.'},//'Period (.)'
        {text: i18n.tc('export.autoExport.fileNamePattern.space'), value: ' '},//'Space'
      ] as SeparatorOption[],
      customSeparator: false,
      staticValue: '',
      prefixesConstants: [
        {text: i18n.tc('export.autoExport.fileNamePattern.date'), value: 'date'},//'Date'
        {text: i18n.tc('export.autoExport.fileNamePattern.static'), value: 'static'}//'Static Text'
      ] as PrefixConstant[],
      availablePrefixes: [] as PrefixConstant[],
      loading: false,
      nextId: 0,
      errorMessage: '',
    };
  },
  mounted() {
    this.buildOptions();
    console.log(this.initialPattern);
  },
  watch: {
    exportTypeFileShort(newType: string) {
      this.generatePattern(newType);
    }
  },
  methods: {
    addPrefix() {
      const newPrefix = {id: this.nextId++, type: '', staticValue: ''};
      this.prefixes.push(newPrefix);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    removePrefix(prefixToRemove: PrefixConfig) {
      this.prefixes = this.prefixes.filter(prefix => prefix.id !== prefixToRemove.id);
    },
    generatePattern(type: string) {
      const parts = this.prefixes.map((prefix) => {
        switch (prefix.type) {
          case 'date':
            return `<${prefix.format || 'yyyy-MM-dd'}>`;
          case 'static':
            return `<${prefix.staticValue || '<custom>'}>`;
          case 'dateRange':
            return `<dateRange>`;
          default:
            return `<${prefix.type}>`;
        }
      });

      const pattern = parts.filter(Boolean).join(this.separator) + '.' + (type != null && type != '' ? type : this.exportTypeFileShort);
      this.$emit('update', pattern);
    },
    buildOptions() {
      this.loading = true;
      let newOptions;

      newOptions = [{
        text: i18n.tc('export.autoExport.fileNamePattern.dateRange'),//"Date range",
        value: "dateRange"
      }];

      this.availablePrefixes = [];
      this.prefixesConstants.forEach(value => {
        this.availablePrefixes.push({
          text: value.text,
          value: value.value
        });
      });
      const existingValues = new Set(this.availablePrefixes.map(p => p.value));
      newOptions.forEach(option => {
        if (!existingValues.has(option.value)) {
          this.availablePrefixes.push(option);
        }
      });
      this.parseInitialPattern();
      this.loading = false;
    },
    setSeparator(val: string) {
      const restrictedChars = /[\\/?:*|<>]/;
      let enteredSeparator;
      if (typeof val === 'object' && val !== null && 'value' in val) {
        enteredSeparator = (val as { value: string }).value;
      } else {
        enteredSeparator = val;
      }

      if (restrictedChars.test(enteredSeparator)) {
        this.separator = enteredSeparator.replace(restrictedChars, '');
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.invalidCharactersDetected');
      } else if (!enteredSeparator) {
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.separatorCannotBeEmpty');
      } else {
        this.errorMessage = '';
        this.separator = enteredSeparator;
      }
    },
    validateSeparator(val: string) {
      const restrictedChars = /[\\/?:*|<>]/;
      let char = (typeof val === 'object' && val !== null && 'value' in val) ? (val as { value: string }).value : val;
      if (restrictedChars.test(char)) {
        char = char.replace(restrictedChars, '');
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.invalidCharactersDetected');//'Invalid characters detected ( / \\ ? % * | : < > )'
      } else if (!char) {
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.separatorCannotBeEmpty');//'Separator cannot be empty or contain only invalid characters'
      } else {
        this.errorMessage = '';
      }
      this.separator = char;
    },

    parseInitialPattern() {
      if (!this.initialPattern) {
        return;
      }

      const patternWithoutExtension = this.initialPattern.replace(/\.[^/.]+$/, '');

      // Match all <...> tokens and also remember what's between them (separator detection)
      const tokenAndSeparatorRegex = /<[^>]*>|[^<]+/g;
      const partsWithSeparators = patternWithoutExtension.match(tokenAndSeparatorRegex) || [];

      const tokens: string[] = [];
      const separators: string[] = [];

      for (const element of partsWithSeparators) {
        const part = element.trim();
        if (part.startsWith('<') && part.endsWith('>')) {
          tokens.push(part);
        } else if (part.length > 0) {
          separators.push(part);
        }
      }

      this.separator = separators.length > 0 ? separators[0].trim() : '_';

      this.prefixes = tokens.map(part => {
        const inner = part.slice(1, -1).trim();

        if (inner === 'dateRange') {
          return {
            id: this.nextId++,
            type: 'dateRange',
            staticValue: ''
          };
        } else if ((this.DateTimeFormats as any)[inner] || Object.values(this.DateTimeFormats as any).includes(inner)) {
          return {
            id: this.nextId++,
            type: 'date',
            staticValue: '',
            format: inner
          };
        } else {
          return {
            id: this.nextId++,
            type: 'static',
            staticValue: inner
          };
        }
      });
    },

    escapeRegex(str: string) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  }
})
;
